<template>
	<div class="spec-games" :class="{ 'spec-games--categories': showCategory }">
		<div v-if="showCategory" class="spec-item__category hide-mobile">
			FPS
		</div>
		<div class="spec-games__list">
			<div :key="`game-${game.id}`" v-for="game in prebuildGames">
				<game-fps :game="game" :resolution="resolution" reverse-content />
			</div>
		</div>
	</div>
</template>

<script>
import GameFps from "../prebuild-fps/game-fps";

export default {
	name: "SpecGamesItem",
	components: {
		GameFps
	},
	props: {
		resolution: {
			type: [String, Number],
			default: ""
		},
		prebuildGames: {
			type: [Object, Array],
			default() {
				return {};
			}
		},
		showCategory: {
			type: Boolean,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.spec-games {
	display: flex;
	align-items: center;
	border-bottom: solid 1px #dbdde0;

	@media (min-width: 580px) and (max-width: 991px) {
		justify-content: center;
	}

	&__list {
		display: flex;
		justify-content: space-between;
		padding: 30px 0 25px;
		max-width: max-content;
		margin: 0 auto;

		@media (max-width: 580px) {
			justify-items: center;
			max-width: 400px;
			margin: 0 auto;
		}

		@media (min-width: 991px) and (max-width: 1200px) {
			padding: 30px 15px 25px;
		}

		& > div:not(:last-child) {
			margin-right: 15px;
		}
	}

	.hide-mobile {
		display: none;

		@media (min-width: 991px) {
			display: block;
		}
	}
}

.spec-games--categories {
	.spec-games__list {
		@media (min-width: 991px) and (max-width: 1200px) {
			padding: 30px 15px 25px 0;
			margin: 0;
		}

		@media (min-width: 1200px) {
			padding: 30px 20px 25px 0;
		}
	}
}

.spec-games::v-deep {
	.prebuild-game__cover {
		width: 82px;
		height: 108px;

		@media (min-width: 991px) and (max-width: 1200px) {
			width: 75px;
			height: 100px;
		}
	}
}
</style>
